import { useEffect, useRef, useState } from 'react';

const FINISHED_TEXT = '00 : 00 : 00';

const formatRemainingTime = (finishedAt: string): string => {
  const diff = new Date(finishedAt).getTime() - Date.now();
  if (diff <= 0) return FINISHED_TEXT;

  const totalSeconds = Math.floor(diff / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, '0')} : ${String(minutes).padStart(2, '0')} : ${String(seconds).padStart(2, '0')}`;
};

type UseCountdownOptions = {
  onFinish?: () => void;
};

export const useCountdown = (
  finishedAt?: string | null,
  options?: UseCountdownOptions,
) => {
  const [timeText, setTimeText] = useState(() =>
    finishedAt ? formatRemainingTime(finishedAt) : null,
  );
  const onFinishRef = useRef(options?.onFinish);
  onFinishRef.current = options?.onFinish;

  useEffect(() => {
    if (finishedAt == null) return;

    setTimeText(formatRemainingTime(finishedAt));
    const interval = setInterval(() => {
      const remaining = formatRemainingTime(finishedAt);
      setTimeText(remaining);
      if (remaining === FINISHED_TEXT) {
        clearInterval(interval);
        onFinishRef.current?.();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [finishedAt]);

  const isFinished = timeText === FINISHED_TEXT;

  return { timeText, isFinished };
};
